<fuse-widget class="widget p-0 h-100-p" fxLayout="column">
    <attachments class="h-100-p mat-white-bg mat-elevation-z2" [subject]='this.subject'></attachments>          
</fuse-widget>